import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { handlePostRequest } from "../../../services/PostTemplate";

const StyledDiv = styled.div`
    padding: 16px;
    border: 1px solid #ccc;
    border-radius: 8px;
    max-width: 300px;
    margin: 20px auto;
    text-align: center;

    &.verifying {
        background-color: #f3f4f6;
    }

    &.success {
        background-color: #d1e7dd;
        color: #0f5132;
    }

    &.expired {
        background-color: #f8d7da;
        color: #842029;
    }
`;

function VerifyUser({ jwt, handleVerifyUser }) {
    const [status, setStatus] = useState("verifying");

    const verifyUser = async () => {
        try {
            const res = await handlePostRequest({ jwt: jwt }, "zbizgateway/nonFin/sendOTPToResetPwd/");
            console.log(res);
            handleVerifyUser();
            setStatus("success");
        } catch (error) {
            console.log(error);
            setStatus("expired");
        }
    };

    useEffect(() => {
        if (jwt) {
            verifyUser();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [jwt]);

    let message;
    switch (status) {
        case "verifying":
            message = "Verifying user...";
            break;
        case "success":
            message = "User verified!";
            break;
        case "expired":
            message = "Verification link expired!";
            break;
        default:
            message = "Verifying user...";
    }

    return <StyledDiv className={status}>{message}</StyledDiv>;
}

export default VerifyUser;
